import styled from 'styled-components';
import { Inset } from '../../spacing';
import { colors, lineHeights, notificationBar, spacing } from '../../../defaultTheme';
export const NotificationRibbon = styled.div `
  background-color: ${({ type }) => notificationBar[type].background};
  border-bottom: 1px solid ${colors.lightGrey};
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'auto')};
  line-height: ${lineHeights.root};
`;
export const FlexWrapper = styled.div `
  display: flex;
`;
export const LeftIconWrapper = styled.div `
  color: ${({ type }) => notificationBar[type].badgeBackground};
  width: ${spacing.large}px;
  height: ${spacing.large}px;
`;
export const RightIconWrapper = styled(Inset) `
  color: ${({ type }) => notificationBar[type].badgeBackground};
`;
export const BodyWrapper = styled.div `
  flex-grow: 1;
  display: inline-block;
  white-space: ${({ isTruncated, hasSubTitle }) => isTruncated && !hasSubTitle ? 'nowrap' : 'normal'};
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const Badge = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ type }) => notificationBar[type].badgeBackground};
  border-radius: 20px;
  min-width: 23px;
  height: 20px;
  color: ${colors.white};
  margin-top: 2px;
`;
